module.exports = __webpack_public_path__ + "static/media/roiHero1x.2218dd95.png";